import React from 'react';
import { ButtonMoreStyled } from './show-more-button.styled';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import { IconSize } from '@constants';
import { useTheme } from '@mui/material';
interface Props {
  open: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}
export const ShowMoreButton = ({ onClick: handleClick, open }: Props) => {
  const theme = useTheme();
  return (
    <ButtonMoreStyled
      data-qa="show-more-button"
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClick}
    >
      <EllipsisVerticalIcon
        height={IconSize.md}
        color={theme.palette.white.main}
      />
    </ButtonMoreStyled>
  );
};
